module.exports = __webpack_public_path__ + "b49b676a6e1c62fff406a8d1367c228c.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./src/font/OpenSans-Bold.eot
 ** module id = 355
 ** module chunks = 9
 **/